import { ThemeProvider as ThemeProvider$1 } from '@emotion/react';
import React__default from 'react';
import { theme } from '@stacks/ui-theme';
import { ColorModes } from './color-modes/styles.esm.js';
import './color-modes/index.esm.js';

var ThemeContext = /*#__PURE__*/React__default.createContext(theme);

var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme$1 = _ref$theme === void 0 ? theme : _ref$theme,
      children = _ref.children;
  return /* @__PURE__ */React__default.createElement(ThemeProvider$1, {
    theme: theme$1
  }, /* @__PURE__ */React__default.createElement(ColorModes, null), children);
};

export { ThemeContext, ThemeProvider };
//# sourceMappingURL=theme-provider.esm.js.map
